.time-suggestions {
  z-index: 15001;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  padding: 8px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  overflow: visible;
  position: fixed;

  button {
    border: none;
    background: white;
    color: black;
    padding: 7px 8px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 14px;
    height: 2.75rem;
    width: 2.75rem;

    &:hover {
      background: #f6f6f6;
    }

    &:active {
      background: #e5e5e5;
    }

    &.time-suggestions-item--active {
      background: #e5e5e5;
    }

    &.time-suggestions-item--selected {
      border: 1px solid var(--sbb-color-red125);
      font-weight: 700;
      color: var(--sbb-color-red125);
    }
  }
}

.time-suggestions--hidden {
  display: none !important;
}

.time-suggestions--visible {
  display: block;
}

.time-suggestions-content {
  display: flex;
  gap: 8px;
  width: 100%;
}

.time-suggestions-left {
}

.time-suggestions-right {
}

.time-suggestions-heading {
  margin: 0 0 8px 0;
  font-size: 0.875rem;
  text-align: center;
}

.time-suggestions-hours-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
}

.time-suggestions-minutes-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.time-suggestions-divider {
  width: 1px;
  background: rgba(0, 0, 0, 0.12);
  margin-left: 5px;
  margin-right: 5px;
}
